import { Action, createSelector, Selector, State, StateContext } from '@ngxs/store';
import { FeaturesChangedByServer } from './enabled-features.actions';
import { FeatureEnum } from '../../../samwebDescription/samwin/FeatureEnum';
import _ from 'lodash';
import { Injectable } from '@angular/core';

export interface EnabledFeaturesStateModel {
   enabledFeatures: string[];
}

@State<EnabledFeaturesStateModel>({
   name: 'enabledFeatures',
   defaults: {
      enabledFeatures: [],
   },
})
@Injectable()
export class EnabledFeaturesState {
   @Selector([EnabledFeaturesState])
   public static getEnabledFeatures(state: EnabledFeaturesStateModel): FeatureEnum[] {
      const features = state.enabledFeatures.map((x) => FeatureEnum.valueOf(x));
      return features;
   }

   @Selector([EnabledFeaturesState])
   public static allowedToManuallyRecord(state: EnabledFeaturesStateModel): boolean {
      return (
         state.enabledFeatures.includes(FeatureEnum.USE_AGENT_CALL_RECORDING.value) &&
         state.enabledFeatures.includes(FeatureEnum.ALLOW_MANUAL_CALL_RECORDING.value)
      );
   }

   @Selector([EnabledFeaturesState])
   public static isSupervisor(state: EnabledFeaturesStateModel): boolean {
      return state.enabledFeatures.includes(FeatureEnum.PROVIDE_SUPERVISOR.value);
   }

   public static isFeatureEnabled(feature: FeatureEnum): (features: FeatureEnum[]) => boolean {
      return createSelector([EnabledFeaturesState.getEnabledFeatures], (enabledFeatures: FeatureEnum[]) => {
         return _.includes(enabledFeatures, feature);
      });
   }

   public static isAnyFeatureEnabled(features: FeatureEnum[]): (features: FeatureEnum[]) => boolean {
      return createSelector([EnabledFeaturesState.getEnabledFeatures], (enabledFeatures: FeatureEnum[]) => {
         return _.difference(features, enabledFeatures).length < features.length;
      });
   }

   public static areAllFeatureEnabled(features: FeatureEnum[]): (features: FeatureEnum[]) => boolean {
      return createSelector([EnabledFeaturesState.getEnabledFeatures], (enabledFeatures: FeatureEnum[]) => {
         return _.difference(features, enabledFeatures).length === 0;
      });
   }

   public static isFeatureEnabledByFeatureName(featureAsString: string): (features: FeatureEnum[]) => boolean {
      const feature = FeatureEnum.valueByName(featureAsString);
      return EnabledFeaturesState.isFeatureEnabled(feature);
   }

   @Action(FeaturesChangedByServer)
   public featuresChangedByServer(ctx: StateContext<EnabledFeaturesStateModel>, action: FeaturesChangedByServer) {
      ctx.patchState({
         enabledFeatures: action.enabledFeatures,
      });
   }
}
